module.exports = __webpack_public_path__ + "ed5fdfa4db97b83036821ed05f5cbbc5.jpg";